export default __webpack_public_path__ + "static/media/ev-charge-point-fast.14a7b62b.svg";